








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { adminInvoiceForModelTableColumns } from '@/modules/invoice/models/columns/admin-invoice-for-model-table.column'
import { Prop } from 'vue-property-decorator'
import { InvoiceForModelCollectionModel } from '@/modules/invoice/models/invoice-for-model-collection.model'
import AdminInvoiceForModelTableRow from '@/modules/invoice/components/admin/table/AdminInvoiceForModelTableRow.vue'

@Component({
  components: {
    TesTable
  }
})
export default class AdminInvoiceForModelTable extends Vue {
  @Prop({ required: true, default: () => [] }) invoiceCollection!: InvoiceForModelCollectionModel[]

  private columns = adminInvoiceForModelTableColumns()

  private rowComponent = AdminInvoiceForModelTableRow
}
